export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] py-10">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 bg-[#16a34a] rounded-md flex items-center justify-center flex-shrink-0">
              <i className="ri-sun-line text-white text-xs"></i>
            </div>
            <span className="font-bold text-white text-base tracking-tight whitespace-nowrap">
              SolarLead<span className="text-[#16a34a]">Source</span>
            </span>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            <a href="/blog" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">Blog</a>
            <a href="/pricing" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">Pricing</a>
            <a
              href="/contact"
              className="text-gray-500 hover:text-gray-300 text-sm transition-colors"
            >
              Contact
            </a>
            <a href="/privacy-policy" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">Privacy Policy</a>
            <a href="/terms-of-service" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">Terms of Service</a>
          </div>

          {/* Copyright */}
          <p className="text-gray-600 text-sm">
            &copy; {new Date().getFullYear()} SolarLeadSource.com. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
